import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {
  Router, Resolve, RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { HeaderAndNavigationService } from '../headerandnavigation.service';

@Injectable()
export class LoginResolver implements Resolve<any> {
  constructor(private headerAndNavigationService: HeaderAndNavigationService, private router: Router) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.headerAndNavigationService.ClearUserData();
  }
}



// WEBPACK FOOTER //
// ./src/app/headerandnavigation/login/login.resolver.ts